module.exports = __webpack_public_path__ + "img/Ana_fran_trener.6cece09c.jpg";